import React        from 'react';
import Link         from 'next/link';

export default class JobList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            job: [
                {
                    title: 'Графический дизайнер',
                    position: 'Креатив',
                    desc: 'MOVER ищет талантливого графического дизайнера, который готов вместе с нами совершить революцию в индустрии. Вас ждет много интересной, разной креативной работы и коллектив с амбициозными целями.',
                    tags: 'График работы 5/2, с 11:00 - до 19:00 • Полный рабочий день • Оформление по ТК',
                    price: '60 000 ~ 90 000 ₽',
                    type: 'GROSS',
                    img: '✏',
                    typeId: 3
                },
                {
                    title: 'Главный бухгалтер',
                    position: 'Финансы',
                    desc: 'Мы ищем Главного бухгалтера с профильным опытом работы в логистике или смежных областях , digital-мышлением и инновационным подходом в работе, высокой профессиональной экспертизой, инициативностью, амбициями карьерного роста.',
                    tags: 'График работы 5/2, с 11:00 - до 19:00 • Полный рабочий день • Оформление по ТК ',
                    price: 'По договоренности',
                    type: '',
                    img: '📊',
                    typeId: 1
                },
                {
                    title: 'Support hero',
                    position: 'Управление',
                    desc: 'Наша единая команда профессионалов и молодых талантов растёт с каждым днём. И потому сейчас открыт набор на должность Специалиста Центра Поддержки 1-ой линии.',
                    tags: 'Москва • м.Савёловская • Полный рабочий день 5/2',
                    price: 'до 50 000 ₽',
                    type: 'GROSS',
                    img: '⚡',
                    typeId: 2
                }
            ]
        };
    }

    sentMail = () => {
        var mail = document.createElement("a");
        mail.href = "mailto:info@mover24.ru";
        mail.click();
    };

    renderList = (item, index) => {
        const { tabType } = this.props;

        return (
            <div className={"job-item t-vacancies" + (tabType === 0 ? "" : (tabType !== item.typeId ? " is-hide" : ""))} key={index}>
                <div className="container">
                    <div className="job-item-inner">
                        <button type="button" onClick={this.sentMail} className="btn btn-primary">Откликнуться</button>
                        <div className="job-item-img">
                            <span className="img">{item.img}</span>
                        </div>
                        <div className="job-item-cnt">
                            <div className="job-item-head">
                                <h3 className="title">{item.title}</h3>
                            </div>
                            <p className="job-item__desc">
                                {item.desc}
                            </p>
                            <div className="job-item__tags">{item.tags}</div>
                            <div className="job-item__price">{item.price}</div>
                            <span className="job-item__sum-type">{item.type}</span>
                        </div>
                    </div>
                </div>
            </div>
        )
    };

    render() {
        const { job } = this.state;

        return (
            <div className="job-cnt">
                {job.map(this.renderList)}
            </div>
        );
    }
}